export function parseMaybeJson(payload: string): unknown {
  if (!payload) return payload;
  try {
    return JSON.parse(payload);
  } catch {
    return payload;
  }
}
